// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"b11bebb5","453":"df01ea0d","885":"34bfd21c"}[chunkId] + ".chunk.js";
};